// helpers
import NFA from 'shared/helpers/analytics/NFAnalytics';

export const onPageLoad = () => {
  NFA.firePageView();
};
